<template>
  <div id="home">
    <my-header :page="'login_page'"></my-header>
    <div class="pd20">
      <div class="row">
        <div class="col-md-3 col-sm-3 col-xs-1"></div>
        <div class="col-md-6 col-sm-6 col-xs-10">
          <h3>Đăng nhập</h3>

          <form v-on:submit="login" v-if="stage_number == 1">
            <p v-if="referral_phone"><i class="fa fa-user"></i> Giới thiệu từ: {{referral_phone}}</p>
            <div class="form-group">
              <input
                type="text"
                v-model="phone"
                class="form-control"
                required
                placeholder="Nhập số điện thoại"
              />
            </div>
            <button type="submit" :disabled="working" class="btn btn-success">
              <i v-if="working" class="fas fa-spinner fa-spin"></i>
              Đăng nhập
            </button>
          </form>

          <form v-on:submit="verify" v-if="stage_number == 2">
            <p>Chúng tôi đã gửi mã xác nhận tới số ĐT : {{ phone }}</p>
            <div class="form-group">
              <input
                type="text"
                v-model="code"
                class="form-control"
                required
                placeholder="Nhập mã xác nhận"
              />
            </div>
            <button type="submit" :disabled="working" class="btn btn-success">
              <i v-if="working" class="fas fa-spinner fa-spin"></i>
              Xác nhận
            </button>
          </form>
        </div>
      </div>
    </div>
    <!-- end pd20 -->
  </div>
</template>

<script>
import MyHeader from '@/components/Layout/Header'
import firebase from 'firebase/app'
import 'firebase/auth'
import Utils from '@/helpers/utils'
import {
  EventBus
} from '@/helpers/event-bus'
export default {
  name: 'LoginPage',
  components: {
    MyHeader
  },
  data () {
    return {
      referral_phone: null,
      phone: '',
      code: '',
      working: false,
      user: null,
      // working_verification: false,
      stage_number: 1
    }
  },
  methods: {
    login (e) {
      e.preventDefault()
      console.log(this.phone)
      console.log('login heree')

      var phoneNum = /^0[3|5|7|8|9][0-9]{8}$$/
      if (this.phone.match(phoneNum)) {
        console.log('passed')
        this.working = true
        // this.stage_number = 2;
        var phoneNumber = '+84' + this.phone.substr(1)
        // self= this;
        const appVerifier = window.recaptchaVerifier
        firebase
          .auth()
          .signInWithPhoneNumber(phoneNumber, appVerifier)
          .then((confirmationResult) => {
            console.log('confirmationResult', confirmationResult)
            // SMS sent. Prompt user to type the code from the message, then sign the
            // user in with confirmationResult.confirm(code).
            window.confirmationResult = confirmationResult
            this.stage_number = 2
            this.working = false

            // ...
          })
          .catch((error) => {
            console.log('error', error)
            // Error; SMS not sent
            // ...
          })
      } else {
        this.$alertify.alertWithTitle(
          this.$t('Confirm'),
          this.$t('Số điện thoại bạn nhập không hợp lệ')
        )
      }
    },
    verify (e) {
      e.preventDefault()
      this.working = true
      //  const code = '123456';
      window.confirmationResult
        .confirm(this.code)
        .then((result) => {
          // User signed in successfully.
          const user = result.user
          console.log('user ', user)
          user.getIdToken().then((token) => {
            console.log('token', token)
            this.fetchServerUser(token)
          })
          // ...
        })
        .catch((error) => {
          // User couldn't sign in (bad verification code?)
          // ...
          // console.log("error 2", error);
          this.working = false
          this.$alertify.alertWithTitle(
            this.$t('Confirm'),
            this.$t('Mã không hợp lệ')
          )
        })
    },
    fetchServerUser (token) {
      var formData = {
        token: token
      }

      if (this.referral_phone) {
        formData.referral_phone = this.referral_phone
      }

      Utils.requestV2(this)
        .post('/login/', formData)
        .then((response) => {
          console.log('response is', response)
          this.user = response.data
          // this.user.phone =  this.user.phone.replace('+84','0');
          this.$localStorage.set('user', JSON.stringify(this.user))

          EventBus.$emit('updateUser', this.user)
          if (window.REQUIRE_LOGIN_ROUTE_NAME) {
            let params = window.ROUTE_PARAMS ? window.ROUTE_PARAMS : {}
            this.$router.push({
              name: window.REQUIRE_LOGIN_ROUTE_NAME,
              params: params
            })
          } else {
            this.$router.push({
              name: 'Home'
            })
          }

          Utils.showSuccess(this, this.$t('Login success'))
        })
        .catch((error) => {
          Utils.showErrorMessage(this, error.response)
          console.log('errror')
        })
    }
  },
  mounted () {
    this.referral_phone = this.$route.params.referral_phone
    this.user = Utils.getUser(this)
    if (this.user) {
      this.$router.push({
        name: 'Home'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/LoginPage.vue